export enum PrivacySetting {
  Public = 'Public',
  Private = 'Private',
}
